import { getLocalStorageValue, setLocalStorageValue } from "./functions";

// function to store data along with the timestamp
const saveDataToLocalStorage = (key: string, data: any) => {
  const value = JSON.stringify({
    timestamp: Date.now(),
    data,
  });

  setLocalStorageValue(key, value);
};

// function to retrieve data if not expired else null
const getDataFromLocalStorage = (key: string, expiryTimeInMs: number) => {
  const value = getLocalStorageValue(key);
  if (!value) {
    return null;
  }

  let data;
  try {
    data = JSON.parse(value);
  } catch {
    return null;
  }

  // check if data is expired
  if (Date.now() - data.timestamp > expiryTimeInMs) {
    localStorage.removeItem(key);
    return null;
  }

  return data.data;
};

const getIpLookUpFromIpgeolocation = async () => {
  if (
    window.location.hostname === "localhost" &&
    !process.env.REACT_APP_IPGEO_KEY
  ) {
    return;
  }

  const expiryTimeInMs = 24 * 60 * 60 * 1_000; // 1 day in milliseconds
  const storageKey = "ipLookUpData";

  // check local storage
  const localStorageData = getDataFromLocalStorage(storageKey, expiryTimeInMs);
  if (localStorageData) {
    return localStorageData;
  }

  // fetch from the API if data not found or expired in local storage
  const response = await fetch(
    `https://api.ipgeolocation.io/ipgeo?apiKey=${process.env.REACT_APP_IPGEO_KEY}`,
  );
  const json = await response.json();
  if (json.ip) {
    const data = {
      ip: json.ip,
      country_code: json.country_code2,
      country_name: json.country_name,
    };

    // save to local storage
    saveDataToLocalStorage(storageKey, data);

    return data;
  }

  return null;
};

export const getIpLookup = async ({
  isCountryCodeRequired = false,
}: {
  isCountryCodeRequired?: boolean;
}) => {
  try {
    if (!isCountryCodeRequired) {
      // https://geolocation-db.com/json does not provide correct country code, so we use ipgeolocation.io
      const response = await fetch("https://geolocation-db.com/json/");
      const json = await response.json();
      // api returns "Not found" if the IP is not found
      if (json.IPv4 && json.IPv4 !== "Not found") {
        return {
          ip: json.IPv4,
          country_code: json.country_code,
          country_name: json.country_name,
        };
      }
    }
  } catch {}

  try {
    return await getIpLookUpFromIpgeolocation();
  } catch {}
  return null;
};
